<template>
  <div class="subcat-filters" v-if="subcat['label_' + $i18n.locale] != null">
    <div class="tab">
      <input type="checkbox" :id="subcat.id">
      <div class="tab-label" :class="{deactivated: !subcat.selected}">
        <div class="close" @click="toggleSelected(!value)"><i :id="'eye--'+subcat.id" :class="eyeOpen(value,subcat.id)"></i></div>
        <label class="tab-label-controller" :for="subcat.id">  <i :id="'icon--'+subcat.id" :class="returnIcons(subcat)"></i>
          <span class="tab-label-text">
            {{ subcat['label_' + $i18n.locale] }} <b>{{ '('+subcat.nb+')' }}</b>
          </span>
        </label>
      </div>
      <div class="tab-content">
          <div class="types">
            <div @click="type.selected = !type.selected" v-for="type in subcat.types" :key="type.id" class="type" :class="{selected: type.selected}">{{ type['label_' + $i18n.locale] }} <b>{{ '('+type.nb+')' }}</b> </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>

import _ from 'lodash'
export default {
  props: ['subcat', 'value'],
  computed: {
    selected () {
      return this.subcat.selected
    },
    subcatTypes: function () {
      return _.sortBy(this.subcat.types, 'id')
    }
  },
  methods: {
    toggleSelected (newValue) {
      this.subcat.types.map(type => {
        type.selected = newValue
      })
      this.$emit('input', newValue)
    },
    async returnIcons (subcatItems) {
      var list =
      [
        { title: 'Dépannage alimentaire et aide alimentaire', icon: 'fas fa-heart', color: '#F53240' },
        { title: 'Éducation populaire en sécurité alimentaire', icon: 'fas fa-people-carry', color: '#F53240' },
        { title: 'Jardins', icon: 'fas fa-seedling', color: '#02D56B' },
        { title: 'Marchés fermiers', icon: 'fas fa-tractor', color: '#3984CE' },
        { title: 'Points de chute aliments frais', icon: 'fas fa-truck-loading', color: '#3984CE' },
        { title: 'CommercialData', icon: 'fas fa-people-carry', color: '#F9BE02' }
      ]

      // Wait until the dom element is generated
      while (!document.querySelector('#icon--' + subcatItems.id)) {
        await new Promise(resolve => setTimeout(resolve, 100))
      }

      list.forEach(item => {
        if (item.title === subcatItems.label_fr) {
          var id = document.getElementById('icon--' + subcatItems.id)
          id.className = item.icon
          id.className += ' filter-icon'
          id.style.backgroundColor = item.color
        }
      })
    },
    async eyeOpen (value, subcatID) {
      // Wait until the dom element is generated

      while (!document.querySelector(`#eye--${subcatID}`)) {
        await new Promise(resolve => setTimeout(resolve, 100))
      }

      if (subcatID != null) {
      // console.log(subcatID)
        var id = document.getElementById(`eye--${subcatID}`)
        if (value) {
          id.className = 'far fa-eye'
        } else {
          id.className = 'far fa-eye-slash'
        }
      }
    }
  },
  watch: {
    selected (value) {
      this.subcat.types.map(type => {
        type.selected = value
      })
    }
  }
}
</script>

<style>
.type {
  cursor: pointer;
  opacity: 0.2;
  padding: 4px 25px;
  text-align: left;
}
.type.selected {
  opacity: 1;
}

.filter-icon {
  margin-right: 10px;
  color: white;
  border-radius: 50%;
  border: solid white 1px;
  padding: 6px;
}

</style>
